import React from 'react';
import './Container.scss';

interface IContainer {
  children: React.ReactNode | React.ReactNode[];
}

const Container = ({ children }: IContainer) => {
  return (
    <div className="page-container ">
      <div className="container">
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Container;
